import { render } from "./module-types-list.vue?vue&type=template&id=000aa6ef"
import script from "./module-types-list.vue?vue&type=script&lang=js"
export * from "./module-types-list.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__